/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import ViewDay from "@material-ui/icons/ViewDay";
import Dns from "@material-ui/icons/Dns";
import Build from "@material-ui/icons/Build";
import ListIcon from "@material-ui/icons/List";
import People from "@material-ui/icons/People";
import Assignment from "@material-ui/icons/Assignment";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Chat from "@material-ui/icons/Chat";
import Call from "@material-ui/icons/Call";
import ViewCarousel from "@material-ui/icons/ViewCarousel";
import AccountBalance from "@material-ui/icons/AccountBalance";
import ArtTrack from "@material-ui/icons/ArtTrack";
import ViewQuilt from "@material-ui/icons/ViewQuilt";
import LocationOn from "@material-ui/icons/LocationOn";
import Fingerprint from "@material-ui/icons/Fingerprint";
import AttachMoney from "@material-ui/icons/AttachMoney";
import Store from "@material-ui/icons/Store";
import AccountCircle from "@material-ui/icons/AccountCircle";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Layers from "@material-ui/icons/Layers";
import ShoppingBasket from "@material-ui/icons/ShoppingBasket";
import LineStyle from "@material-ui/icons/LineStyle";
import Error from "@material-ui/icons/Error";
import Header from "components/Header/Header.jsx";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";

function HeaderLinks({ ...props }) {
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const smoothScroll = (e, target) => {
    if (window.location.pathname === "/sections") {
      var isMobile = navigator.userAgent.match(
        /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
      );
      if (isMobile) {
        // if we are on mobile device the scroll into view will be managed by the browser
      } else {
        e.preventDefault();
        var targetScroll = document.getElementById(target);
        scrollGo(document.documentElement, targetScroll.offsetTop, 1250);
      }
    }
  };
  const scrollGo = (element, to, duration) => {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  var onClickSections = {};

  const { classes, dropdownHoverColor } = props;
  return (
    <List className={classes.list + " " + classes.mlAuto}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="About Us"
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/about-us" className={classes.dropdownLink}>
              <LineStyle className={classes.dropdownIcons} /> About Us
            </Link>,
            <Link to="/contact-us" className={classes.dropdownLink}>
              <Layers className={classes.dropdownIcons} />
              Contact Us
            </Link>,
            // <a
            //   href="https://demos.creative-tim.com/material-kit-pro-react/#/documentation/tutorial"
            //   target="_blank"
            //   className={classes.dropdownLink}
            // >
            //   <Icon className={classes.dropdownIcons}>content_paste</Icon>
            //   Documentation
            // </a>
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="What We Do"
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
          }}
          buttonIcon={ViewDay}
          dropdownList={[
            <Link
              to="/universities"
              className={classes.dropdownLink}
              onClick={(e) => smoothScroll(e, "headers")}
            >
              <AccountBalance className={classes.dropdownIcons} /> Universities
            </Link>,
            <Link
              to="/lga"
              className={classes.dropdownLink}
              onClick={(e) => smoothScroll(e, "features")}
            >
              <Store className={classes.dropdownIcons} /> Local Governments
            </Link>,
            <Link
              to="/nsw-training-awards"
              className={classes.dropdownLink}
              onClick={(e) => smoothScroll(e, "features")}
            >
              <Store className={classes.dropdownIcons} /> State Government
            </Link>,
            <Link
              to="/australia-awards"
              className={classes.dropdownLink}
              onClick={(e) => smoothScroll(e, "features")}
            >
              <Store className={classes.dropdownIcons} /> Federal Government
            </Link>,

            // <Link
            //   to="/sections#blogs"
            //   className={classes.dropdownLink}
            //   onClick={e => smoothScroll(e, "blogs")}
            // >
            //   <ListIcon className={classes.dropdownIcons} /> Blogs
            // </Link>,
            // <Link
            //   to="/sections#teams"
            //   className={classes.dropdownLink}
            //   onClick={e => smoothScroll(e, "teams")}
            // >
            //   <People className={classes.dropdownIcons} /> Teams
            // </Link>,
            // <Link
            //   to="/sections#projects"
            //   className={classes.dropdownLink}
            //   onClick={e => smoothScroll(e, "projects")}
            // >
            //   <Assignment className={classes.dropdownIcons} /> Projects
            // </Link>,
            // <Link
            //   to="/sections#pricing"
            //   className={classes.dropdownLink}
            //   onClick={e => smoothScroll(e, "pricing")}
            // >
            //   <MonetizationOn className={classes.dropdownIcons} /> Pricing
            // </Link>,
            // <Link
            //   to="/sections#testimonials"
            //   className={classes.dropdownLink}
            //   onClick={e => smoothScroll(e, "testimonials")}
            // >
            //   <Chat className={classes.dropdownIcons} /> Testimonials
            // </Link>,
            // <Link
            //   to="/sections#contacts"
            //   className={classes.dropdownLink}
            //   onClick={e => smoothScroll(e, "contacts")}
            // >
            //   <Call className={classes.dropdownIcons} /> Contacts
            // </Link>
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Courses"
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
          }}
          buttonIcon={ViewCarousel}
          dropdownList={[
            <Link to="/courses" className={classes.dropdownLink}>
              <ViewQuilt className={classes.dropdownIcons} /> All Courses
            </Link>,
            <Link
              to="/product-page/leadership-introduction-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Introduction to
              Leadership
            </Link>,
            <Link
              to="/product-page/civic-leadership-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Civic Leadership
            </Link>,
            <Link
              to="/product-page/communication-strategies-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Master
              Communication Skills
            </Link>,
            <Link
              to="/product-page/presentation-skills-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Presentation
              Skills
            </Link>,
            <Link
              to="/product-page/conflict-resolution-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Conflict
              Resolution Skills
            </Link>,
            <Link
              to="/product-page/event-planning-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Event Planning
              Skills
            </Link>,
            <Link
              to="/product-page/event-marketing-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Event Marketing
              Skills
            </Link>,
            <Link
              to="/product-page/global-ambassador-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Global Ambassador
            </Link>,
            <Link
              to="/product-page/meeting-management-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Meeting Management
            </Link>,
            <Link
              to="/product-page/professional-brand-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Professional Brand
            </Link>,
            <Link
              to="/product-page/teamwork-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Teamwork Skills
            </Link>,
            <Link
              to="/product-page/networking-page"
              className={classes.dropdownLink}
            >
              <ViewQuilt className={classes.dropdownIcons} /> Networking Skills
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/contact-us">
          <Button
            color={window.innerWidth < 960 ? "info" : "white"}
            className={classes.navButton}
            round
          >
            Contact us
          </Button>
        </Link>
      </ListItem>
    </List>
  );
}

HeaderLinks.defaultProps = {
  hoverColor: "primary",
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
  ]),
};

export default withStyles(headerLinksStyle)(HeaderLinks);
